// Complete Keyboard Shortcut Reference

export type Platform = 'mac' | 'win';

export interface ShortcutInfo {
  mac?: string;
  win?: string;
  combo?: string;
  label: string;
}

export const PLATFORM: Platform = /Mac/i.test(navigator.platform) ? 'mac' : 'win';

export const SHORTCUTS: Record<string, ShortcutInfo> = {
  bold: { mac: '⌘B', win: 'Ctrl+B', combo: 'Mod+b', label: 'Bold' },
  italic: { mac: '⌘I', win: 'Ctrl+I', combo: 'Mod+i', label: 'Italic' },
  underline: { mac: '⌘U', win: 'Ctrl+U', combo: 'Mod+u', label: 'Underline' },
  strike: { mac: '⌘⇧X', win: 'Ctrl+Shift+X', combo: 'Mod+Shift+x', label: 'Strikethrough' },
  link: { mac: '⌘K', win: 'Ctrl+K', combo: 'Mod+k', label: 'Link' },
  bulletList: { mac: '⌘⇧8', win: 'Ctrl+Shift+8', combo: 'Mod+Shift+8', label: 'Bullet List' },
  orderedList: { mac: '⌘⇧7', win: 'Ctrl+Shift+7', combo: 'Mod+Shift+7', label: 'Numbered List' },
  heading1: { mac: '⌘⌥1', win: 'Ctrl+Alt+1', combo: 'Mod+Alt+1', label: 'Heading 1' },
  heading2: { mac: '⌘⌥2', win: 'Ctrl+Alt+2', combo: 'Mod+Alt+2', label: 'Heading 2' },
  heading3: { mac: '⌘⌥3', win: 'Ctrl+Alt+3', combo: 'Mod+Alt+3', label: 'Heading 3' },
  undo: { mac: '⌘Z', win: 'Ctrl+Z', combo: 'Mod+z', label: 'Undo' },
  redo: { mac: '⌘⇧Z', win: 'Ctrl+Shift+Z', combo: 'Mod+Shift+z', label: 'Redo' },
  // Simple label without shortcuts
  insertTable: { label: 'Insert Table' },
  horizontalRule: { label: 'Horizontal Line' },
  highlight: { label: 'Highlight' }
};

export const comboFor = (key: string): string => SHORTCUTS[key]?.[PLATFORM] || ''; 